import * as Icons from './svgLibrary'

type CustomEmoji = {
  id: string
  name: string
  keywords: string[]
  icon: string
}

export const emojis: CustomEmoji[] = [
  {
    id: 'whatsapp',
    name: 'WhatsApp',
    keywords: ['whatsapp'],
    icon: Icons.WhatsApp
  },
  {
    id: 'telegram',
    name: 'Telegram',
    keywords: ['telegram'],
    icon: Icons.Telegram
  },
  {
    id: 'instagram',
    name: 'Instagram',
    keywords: ['instagram'],
    icon: Icons.Instagram
  },
  {
    id: 'linkedin',
    name: 'LinkedIn',
    keywords: ['linkedin'],
    icon: Icons.LinkedIn
  },
  {
    id: 'twitter',
    name: 'Twitter',
    keywords: ['twitter'],
    icon: Icons.Twitter
  },
  {
    id: 'facebook',
    name: 'Facebook',
    keywords: ['facebook'],
    icon: Icons.Facebook
  }
]
